import React, { useEffect } from "react";
import style from "./Modal.module.scss";

import Carousel from "../Portfolio/Carousel/Carousel.js";

export default function Modal({ setModal, modal }) {
  useEffect(() => {
    function closeModal(e) {
      if (modal.show === true && e.target.id === "container_modal") {
        setModal((prev) => ({ ...prev, show: false }));
      }
    }
    document.addEventListener("click", closeModal);

    return () => document.removeEventListener("click", closeModal);
  }, [modal, setModal]);

  return (
    <div className={style.container} id="container_modal">
      <div className={style.container__content}>
        <div className={style.container__content__header}>
          <div className={style.container__content__header__close}>
            <i
              onClick={() => setModal((prev) => ({ ...prev, show: false }))}
              className="bi bi-x"
            ></i>
          </div>
          <h3>{modal?.data?.title}</h3>
        </div>
        <div className={style.container__content__data}>
          {modal?.data?.images?.length > 0 && (
            <div className={style.container__content__data__img}>
              <Carousel images={modal?.data?.images} />
            </div>
          )}

          <div
            style={
              modal?.data?.images?.length > 0 && window.innerWidth > 960
                ? { width: "50%" }
                : { width: "100%" }
            }
            className={style.container__content__data__extendedInformation}
          >
            <div
              className={
                style.container__content__data__extendedInformation__technology
              }
            >
              {modal?.data?.technology.split(",").map((t) => {
                return <p key={t}>{t}</p>;
              })}
            </div>
            <div
              className={
                style.container__content__data__extendedInformation__content
              }
            >
              <p>
                {modal?.data?.text}{" "}
                {modal?.data?.templateimg && (
                  <a
                    href={modal?.data?.templateimg}
                    title="Imagen en la que me base para diseñar la plantilla"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver Imagen
                  </a>
                )}
              </p>
            </div>
            <div
              className={
                style.container__content__data__extendedInformation__buttons
              }
            >
              <a
                className={
                  style.container__content__data__extendedInformation__buttons_github
                }
                href={modal?.data?.linkGithub}
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-github"></i>
                Ver Repositorio{" "}
              </a>
              {modal?.data?.deployed === "finished" ? (
                <a
                  href={modal?.data?.linkDeploy}
                  target="_blank"
                  rel="noreferrer"
                  className={
                    style.container__content__data__extendedInformation__buttons_link
                  }
                >
                  <i className="bi bi-link"></i>
                  Ver Pagina
                </a>
              ) : (
                <p>{modal?.data?.deployed}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
